/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CollectionPackagingUnitCreateRequest } from '../../models/collection-packaging-unit-create-request';
import { CollectionPackagingUnitCreateResponse } from '../../models/collection-packaging-unit-create-response';

export interface CreateCollectionPackagingUnit$Params {

/**
 * UUID of the parent product (PackagingUnit)
 */
  packagingUnitId: string;
      body: CollectionPackagingUnitCreateRequest
}

export function createCollectionPackagingUnit(http: HttpClient, rootUrl: string, params: CreateCollectionPackagingUnit$Params, context?: HttpContext): Observable<StrictHttpResponse<CollectionPackagingUnitCreateResponse>> {
  const rb = new RequestBuilder(rootUrl, createCollectionPackagingUnit.PATH, 'post');
  if (params) {
    rb.path('packagingUnitId', params.packagingUnitId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CollectionPackagingUnitCreateResponse>;
    })
  );
}

createCollectionPackagingUnit.PATH = '/products/{packagingUnitId}/collections';
